// extracted by mini-css-extract-plugin
export default {"loaderContainer":"api-info_loaderContainer__sby-q","errorContainer":"api-info_errorContainer__GH6pG"};